<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid.is-tablet-6.is-widescreen-4
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4 {{item.title}}
        p {{item.desc}}


  section.u-mt-md
    .grid.is-widescreen-8.is-desktop-10
      .column
        h4 {{$t('cta')}}
    AppLink(to="/contact" :title="$t('ctaBtn')" class="button-link  " v-html="$t('ctaBtn')")

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4: AppLink(:to="item.url" :title="item.title") {{item.title}}
            p {{item.desc}}


  section.u-mt-md.u-mb-md
    AppLink(to="/events/meetups/guidelines" :title="$t('cta2')" class="button-link is-large " v-html="$t('cta2')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat meetups",
    "pageDesc":"Baianat meetups are events that gather local communities together for insightful conversations and knowledge sharing.",
    "mantra":"Gathering local |communities.",
    "mantraDesc":"Baianat meetups are self-organized local gatherings usually made by Baianat ambassadors, seeders or brand evangelists. It’s a great opportunity to socialize with industry peers and discuss field related matters.",
    "sec1Items":{
      "1":{
        "title":"Designers meetups",
        "desc":"Share inspiring stories and bond with your local community of designers. Expand your network by meeting designers from different fields and engaging in meaningful conversations."
      },
      "2":{
        "title":"Developers meetups",
        "desc":"Share the challenges and the passion for developing out-of-the-box solutions. Get yourself into a local community of developers and learn more on the latest technologies in your field."
      },
      "3":{
        "title":"Strategists meetups",
        "desc":"Creating a place where business geeks gather for discussions that extend from venture capliting to economics and globalization."
      }
    },
    "cta":"Be the host of our next community gathering. Whether a 20 persons meetup, in your company or outdoors, we are looking forward to having you on board!",
    "ctaBtn":"Become a meetup host",
    "sec2":"Get ready for the next meetup!",
    "sec2Items":{
      "1":{
        "title":"JS",
        "desc":"Join the top developers in a skillsharing meetup where hacks and tips are dominating the playground.",
        "url":"/events/meetups/js"
      },
      "2":{
        "title":"iOS",
        "desc":"Discover the latest in iOS development and add our issues solving experience to  yours with insightful and details How-to tips.",
        "url":"/events/meetups/ios"
      },
      "3":{
        "title":"Android",
        "desc":"Exploring a new territory in Android with you and showcasing our biggest challenges along with our takes on the latest technology.",
        "url":"/events/meetups/android"
      },
      "4":{
        "title":"Big data and analytics",
        "desc":"Sharing our experience in reports creation and forecasting to give you a hint on what happens in our big data and analytics kitchen.",
        "url":"/events/meetups/big-data-and-analytics"
      },
      "5":{
        "title":"User experience",
        "desc":"Customer centric conversations backed with reports, analytics and scientific facts that we tested and proved to be outperforming.",
        "url":"/events/meetups/user-experience"
      },
      "6":{
        "title":"Branding",
        "desc":"From visuals to strategy, we tackle with you the very in depth details of branding as a science and how it connects with other related fields like business and marketing.",
        "url":"/events/meetups/branding"
      },
      "7":{
        "title":"Type design",
        "desc":"Learn the hacks of letters in both Lain and arabic alphabets and get a closer look into our foundry and type design process.",
        "url":"/events/meetups/type-design"
      },
      "8":{
        "title":"Product design",
        "desc":"Learn more on the basics of product design and how we mix high performance with functional and appealing design.",
        "url":"/events/meetups/product-design"
      },
      "9":{
        "title":"Design thinking",
        "desc":"Learn how we go through every design project,  the iteration we pass by before choosing a final concept and how to build on your design thinking method.",
        "url":"/events/meetups/design-thinking"
      },
      "10":{
        "title":"Business",
        "desc":"Sharing real case studies of projects we have worked on and having open discussions from which you can gain more insights.",
        "url":"/events/meetups/business"
      },
      "11":{
        "title":"Digital Marketing",
        "desc":"Get familiar with the hacks of the digital channels and know how we link marketing, branding and business goals.",
        "url":"/events/meetups/digital-marketing"
      }
    },
    "cta2":"Read our meetup<br> guidelines"
  },
  "ar": {
    "pageTitle":"ملتقيات بيانات",
    "pageDesc":"لقاءات بيانات هى الأحداث والتجمعات المحلية التي تؤسسها من أجل تبادل المحادثات والرؤى ومشاركة المعرفة والخبرات.",
    "mantra":"تجمعات محلية لتبادل |المعارف والخبرات",
    "mantraDesc":"ملتقيات بيانات هي تجمعات محلية تم تنظيمها ذاتياً، وفي الأغلب يتم تنظيمها من خلال سفراء بيانات أو ناشرون بيانات أو مبشري العلامة التجارية. تعتبر فرصة رائعة للتواصل مع أقرانك في المجال ومناقشة الأمور المتعلقة به.",
    "sec1Items":{
      "1":{
        "title":"ملتقيات المصممين",
        "desc":"شارك القصص الملهمة وارتبط أكثر مع مجتمعك المحلي من المصممين. وسيع شبكتك من خلال مقابلة المصممين من مختلف المجالات وتبادل المحادثات ذات المغزى."
      },
      "2":{
        "title":"ملتقيات المبرمجين",
        "desc":"شارك التحديات والشغف من أجل تطوير حلول شاملة. تعرف على المجتمع المحلي من المطورين وتعلم المزيد حول أحدث التقنيات في مجال عملك."
      },
      "3":{
        "title":"ملتقيات الاستراتيجيين",
        "desc":"تأسيس مكان يجتمع فيه رجال الأعمال المهتمين بالمناقشات الفعالة حول المجال التي تبدأ من رأس المال المخاطر وحتى الاقتصاد والعولمة."
      }
    },
    "cta":"كن المضيف لاجتماعنا القادم. سواء كنت تلتقي بـ 20 شخصًا، في شركتك أو في الهواء الطلق، نتطلع إلى وجودك على متن الرحلة!",
    "ctaBtn":"كن مضيفًا لملتقيات بيانات",
    "sec2":"كن مستعدًا للقاء القادم!",
    "sec2Items":{
      "1":{
        "title":"جافا سكريبت",
        "desc":"انضم إلى فريق المبرمجين من أجل مشاركة المهارات المختلفة للتعرف على النصائح البرمجية التي تحتاجها.",
        "url":"/events/meetups/js"
      },
      "2":{
        "title":"آي أو إس",
        "desc":"اكتشف أحدث التطورات في برمجة iOS وأضف الحلول التي توصلنا إليها في المشكلات المختلفة إلي خبرتك، من خلال رؤى واضحة وخطوات محددة.",
        "url":"/events/meetups/ios"
      },
      "3":{
        "title":"الأندرويد",
        "desc":"تعرف على رؤى جديدة في الأندرويد وتعرف على مختلف التحديات جنبًا إلى جنب مع أحدث التقنيات لدينا.",
        "url":"/events/meetups/android"
      },
      "4":{
        "title":"البيانات الضخمة والتحليلات",
        "desc":"نتشارك خبراتنا في إعداد التقارير والتنبؤ بها من خلال منحك مختلف الأساليب التي نقوم بها في مطبخ التحليلات والبيانات الخاص بنا.",
        "url":"/events/meetups/big-data-and-analytics"
      },
      "5":{
        "title":"تجربة المستخدم",
        "desc":"تعرف على المزيد حول تجربة المستخدم من خلال التقارير والتحليلات والحقائق التي اختبرناها وأثبتت أنها ناجحة.",
        "url":"/events/meetups/user-experience"
      },
      "6":{
        "title":"الهوية التجارية",
        "desc":"من المرئيات إلى الاستراتيجية، ندقق في مختلف التفاصيل للعلامة التجارية كعلم، وكيف ترتبط بالمجالات الأخرى ذات الصلة مثل الأعمال والتسويق.",
        "url":"/events/meetups/branding"
      },
      "7":{
        "title":"تصميم الخطوط",
        "desc":"تعرف على آخر النصائح حول الحروف لكل من الحروف الهجائية اللاتينية والعربية، واحصل على نظرة شاملة حول عملية تصميم الحروف بأكملها.",
        "url":"/events/meetups/type-design"
      },
      "8":{
        "title":"تصميم المنتجات",
        "desc":"اعرف المزيد حول كيفية تصميم المنتجات وكيفية مزج بين الأداء العالي مع التصميم الوظيفي وفي نفس الوقت يتمتع بالجاذبية.",
        "url":"/events/meetups/product-design"
      },
      "9":{
        "title":"التفكير التصميمي",
        "desc":"احصل على معرفة شاملة حول المراحل التي نمر بها خلال كل مشروع، والتكرار الذي نقوم به من أجل التوصل إلى النسخة النهائية،  وكيف تقوم ببناء طريقتك الخاصة في التفكير التصميمي.",
        "url":"/events/meetups/design-thinking"
      },
      "10":{
        "title":"الأعمال التجارية",
        "desc":"نتبادل دراسات حالة حقيقية للمشاريع التي عملنا عليها، ونجري مختلف المناقشات التي تساعدك على الحصول على مختلف الأفكار والرؤى الثاقبة.",
        "url":"/events/meetups/business"
      },
      "11":{
        "title":"التسويق",
        "desc":"احصل على نصائح و رؤى حول القنوات الرقمية المختلفة وتعرف كيف نربط ما بين أهداف التسويق والعلامة التجارية وأهداف العمل التجاري.",
        "url":"/events/meetups/digital-marketing"
      }
    },
    "cta2":"اقرأ إرشادات<br> الملتقيات"
  }
}
</i18n>
